import type {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
} from "@angular/forms";

// Validator for complexity
export function passwordComplexityValidator(username: string): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;
		if (!value) {
			return null;
		}
		const hasUpperCase = /[A-Z]+/.test(value);
		const hasLowerCase = /[a-z]+/.test(value);
		const hasNumeric = /[0-9]+/.test(value);
		const hasSpecial = /[!@#$%^&*(),.?":{}|<>]+/.test(value);
		const hasUserName = value.toLowerCase().includes(username.toLowerCase());
		const isValid =
			hasUpperCase && hasLowerCase && hasNumeric && hasSpecial && !hasUserName;
		return isValid ? null : { passwordComplexity: true };
	};
}

// Validator to check if given data match
/**
 * @deprecated Use matchPasswordValidator instead.
 */
export function mustMatch(controlName: string, matchingControlName: string) {
	return (formGroup: FormGroup) => {
		const control = formGroup.controls[controlName];
		const matchingControl = formGroup.controls[matchingControlName];

		if (matchingControl.errors && !matchingControl.errors["mustMatch"]) {
			return;
		}

		if (control.value !== matchingControl.value) {
			matchingControl.setErrors({ mustMatch: true });
		}
	};
}
export function matchPasswordValidator(): ValidatorFn {
	return (group: AbstractControl): ValidationErrors | null => {
		const password = group.get("password")?.value;
		const confirmPassword = group.get("confirmPassword");
		if (!confirmPassword) return null;
		if (password !== confirmPassword.value) {
			confirmPassword.setErrors({ mustMatch: true });
			return { mustMatch: true };
		} else {
			// Only clear mustMatch error, not other errors
			if (confirmPassword.hasError("mustMatch")) {
				const errors = { ...confirmPassword.errors };
				delete errors["mustMatch"];
				confirmPassword.setErrors(Object.keys(errors).length ? errors : null);
			}
			return null;
		}
	};
}
